export default __webpack_public_path__ + "99ba0b533d4439fc1196522783d3426f.png";